import { locateRoute } from '../../modules/moduleCatalog';
import { ModuleKey } from '../registry/types';

/**
 * KPI tile key → the list page behind the number. A tile without an entry (or whose page the user
 * cannot open) stays a plain figure.
 */
export const TILE_LINKS: Record<string, string> = {
    'att.present': '/attendance/today',
    'att.absent': '/attendance/today',
    'att.leave': '/attendance/today',
    'att.rate': '/attendance/today',
    'leave.pending': '/all-leave-applications',
    'leave.today': '/all-leave-applications',
    'people.active': '/users',
    'people.inactive': '/users',
    'acc.cash': '/banking/cash-position',
    'acc.ar': '/sales/invoices',
    'acc.overdue': '/sales/reports/aging',
    'acc.ap': '/procurement/reports',
    'acc.income': '/accounting/income-statement',
    'acc.expense': '/accounting/income-statement',
    'acc.net': '/accounting/income-statement',
    'sales.mtd': '/sales/invoices',
    'sales.pipeline': '/crm/pipeline',
    'sales.deals': '/crm/pipeline',
    'inv.value': '/stocks',
    'inv.items': '/items',
    'inv.low': '/low-stock',
    'req.pending': '/pending-approval-requisitions',
    'pay.net': '/payroll/run',
    'pay.headcount': '/payroll/run',
    'exp.pending': '/expense/pending-approval',
    'exp.amount': '/expense/pending-approval',
    'exp.oldest': '/expense/pending-approval',
    'ws.approvals': '/approvals',
    'ws.journalsAwaiting': '/accounting/journal-entries',
    'ws.journalsPosted': '/accounting/journal-entries',
    'ws.journalsReversed': '/accounting/journal-entries',
    'ws.billsDue7': '/procurement/supplier-bills',
    'ws.overdueBills': '/procurement/supplier-bills',
    'ws.billsHold': '/procurement/supplier-bills',
    'ws.runsDraft': '/procurement/payment-runs',
    'ws.runsAwaiting': '/procurement/payment-runs',
    'ws.issuedCheques': '/banking/cheques',
    'ws.receivedPdc': '/banking/cheques',
    'ws.overdueInvoices': '/sales/invoices',
    'ws.ar60': '/sales/reports/aging',
    'ws.promises': '/sales/collections',
    'ws.unreconciled': '/banking/unreconciled',
    'ws.nextDeadline': '/accounting/compliance-calendar',
};

/**
 * The tile's page when the user can reach it from the sidebar (same module card, page gate and
 * enabled-module checks), so a click never lands on a page they are not allowed to open.
 */
export function tileLinkFor(
    key: string,
    visibility: Record<string, boolean>,
    enabledModules: Set<ModuleKey>,
): string | undefined {
    const path = TILE_LINKS[key];
    if (!path) return undefined;
    const loc = locateRoute(path);
    if (!loc || !loc.exact) return undefined;
    const { card, link } = loc;
    if (visibility[card.key] !== true) return undefined;
    if (card.gatedModule && !enabledModules.has(card.gatedModule)) return undefined;
    if ((card.alsoGatedModules ?? []).some(k => !enabledModules.has(k))) return undefined;
    if (link?.gate && visibility[link.gate] !== true) return undefined;
    return path;
}
